import { headerLinkListStyles as linkListStyle } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import { StyledButton } from "@insite/mobius/Clickable";
import { StyledTypography } from "@insite/mobius/Link";
import { colorPalette, colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

linkListStyle.link = {
    ...linkListStyle.link,
    typographyProps: {
        color: colorStrings.secondaryMain,
        css: css`
            margin: 0 9px 0 9px;
            display: inline-block;
        `,
    },
    css: css`
        ${StyledButton} {
            &:hover {
                ${StyledTypography} {
                    border-bottom: 0;
                }
            }
        }
    `,
    hoverStyle: {
        color: colorPalette.secondary.main,
        textDecoration: "underline",
    },
};
